import React from 'react';
import { Container, Title, SimpleGrid, Tabs, Card, Group, Text, Badge } from '@mantine/core';
import { 
  IconDatabase, 
  IconSettings, 
  IconChartBar,
  IconShieldLock 
} from '@tabler/icons-react';
import { CacheControlPanel, CacheConfigPanel, CacheMetricsPanel } from '../../components/admin';
import { useOktaAuth } from '../../providers/okta-auth-provider';
import { Navigate } from '@tanstack/react-router';

export function CacheDashboard() {
  const { checkIsUserInRole } = useOktaAuth();
  const isAdmin = true // TODO checkIsUserInRole(['admin']);
  
  if (!isAdmin) {
    return <Navigate to="/unauthorized" />;
  }
  
  return (
    <Container size="xl" py="xl">
      <Group justify="space-between" mb="lg">
        <Title order={2}>Gestione Cache</Title>
        <Badge color="indigo" size="lg">Admin</Badge>
      </Group>
      
      <Card withBorder p={0} mb="xl">
        <Card.Section withBorder p="md" inheritPadding>
          <Group>
            <IconShieldLock size={20} />
            <Text>
              Questa sezione è accessibile solo agli amministratori e permette di gestire 
              la cache dell'applicazione.
            </Text>
          </Group>
        </Card.Section>
      </Card>
      
      <Tabs defaultValue="metrics">
        <Tabs.List mb="md">
          <Tabs.Tab value="metrics" leftSection={<IconChartBar size={16} />}>
            Metriche
          </Tabs.Tab>
          <Tabs.Tab value="control" leftSection={<IconDatabase size={16} />}>
            Controllo
          </Tabs.Tab>
          <Tabs.Tab value="config" leftSection={<IconSettings size={16} />}>
            Configurazione
          </Tabs.Tab>
        </Tabs.List>
        
        <Tabs.Panel value="metrics">
          <CacheMetricsPanel />
        </Tabs.Panel>
        
        <Tabs.Panel value="control">
          <CacheControlPanel />
        </Tabs.Panel>
        
        <Tabs.Panel value="config">
          <CacheConfigPanel />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
}